import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { analyticsAllowed, onConsentChange } from '@/lib/consent';

const GA_MEASUREMENT_ID = 'G-5ZWEQD4XBE';

const sendPageView = (location) => {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  if (!analyticsAllowed()) return;
  const pagePath = location.pathname + location.search;
  window.gtag('event', 'page_view', {
    page_path: pagePath,
    page_location: window.location.href,
    page_title: document.title,
    send_to: GA_MEASUREMENT_ID,
  });
};

const GAListener = () => {
  const location = useLocation();

  // Fire on route change (only if consented)
  useEffect(() => {
    sendPageView(location);
  }, [location.pathname, location.search]);

  // Fire the current page's view immediately after the user grants consent
  useEffect(() => {
    const off = onConsentChange((e) => {
      if (e?.detail?.analytics) {
        sendPageView(location);
      }
    });
    return off;
  }, [location.pathname, location.search]);

  return null;
};

export default GAListener;
